import { RunWithSummary } from '../../types'
import { RunCard } from './RunCard'
import { Plus, Zap } from 'lucide-react'

interface RunsListProps {
  runs: RunWithSummary[]
  onDeleteRun: (id: string) => void
  deletingRunId?: string | null
}

export function RunsList({ runs, onDeleteRun, deletingRunId }: RunsListProps) {
  if (runs.length === 0) {
    return (
      <div className="text-center py-20">
        <div className="bg-white rounded-full w-20 h-20 mx-auto flex items-center justify-center shadow-minimal mb-6">
          <Zap className="h-8 w-8 text-primary-600" />
        </div>
        <h3 className="text-2xl font-bold text-primary-900 mb-4">
          Ready to plan your next adventure?
        </h3>
        <p className="text-neutral-600 mb-8 max-w-md mx-auto leading-relaxed">
          Create your first ultra run plan and start organizing segments, aid stations, and nutrition strategies.
        </p>
        <div className="bg-primary-50 rounded-2xl p-6 max-w-sm mx-auto border border-primary-100">
          <div className="flex items-center justify-center gap-2 text-primary-700">
            <Plus className="h-5 w-5" />
            <span className="font-medium">Click "New Run" above to get started</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
      {runs.map((run) => (
        <RunCard
          key={run.id}
          run={run}
          onDelete={() => onDeleteRun(run.id)}
          isDeleting={deletingRunId === run.id}
        />
      ))}
    </div>
  )
}